import React from 'react';
import { client_1, client_2, client_3, client_4, client_5, client_6 } from '../../../Shared/Images/image';
import Slider from "react-slick";
import SliderSettings from "../../../Configs/SlickSlider.json";


 
const testimonials=  ()=>{
    const clients =[
       {
        id:1,
        name : "Kelly Smith",
        imageUrl: client_1,
        message :"I am 100% satisfied with Delta Global Consulting's services.!"
       },
       {
        id:2,
        name : "Muhammad Ahsan",
        imageUrl: client_2,
        message : "I have no words to thank Delta Global Consulting who made my dream come true."
       },
       {
        id:3,
        name : "Matt Stocker",
        imageUrl: client_3,
        message : "I have no words to thank Delta Global Consulting who made my dream come true."
       },
       {
        id:4,
        name : "Emily Heath",
        imageUrl: client_4,
        message : "I was refused in previous HSMP law by applying myself but hiring Delta Global Consulting resulted into my HSMP approval. Thanks a lot !"
       },
       {
        id:5,
        name : "Nasir Ali",
        imageUrl: client_5,
        message : "Very smart people working on the project — they provided great insight and brought experience to the project."
       },
       {
        id:6,
        name : "Bilal Saeed",
        imageUrl: client_6,
        message : "I am really impressed with Delta Global Consulting's services and their professional approach."
       }
    ]
    
    return(
        <section className="testmonial-section" id="testmoniaSlider">
            <div className="testmonial-container bg2">
                <div className="ms-width">
                    <h2 className="heading2 text-white fw-sb text-center">Clients Testimonials</h2>
                    <div className="pt-4">
                            <Slider {...SliderSettings} >
                                {
                                   clients.map(client=>{
                                       return(
                                         <div key={client.id}>
                                             <div className="testmonial-slider px-md-5">
                                                <div className="slider-image">
                                                    <img src={ client.imageUrl } className="img-fluid" alt="TestmonialImage" />
                                                </div>
                                                <div className="slider-text bg-white mt-4 mt-md-0">
                                                    <div className="p-4">
                                                        <p className="heading5 font-weight-normal mb-0">{client.message}</p>
                                                        <p className="heading5 font-weight-normal pt-3 text-right mb-0">- {client.name}</p>
                                                    </div>
                                                </div>
                                             </div>
                                         </div>
                                       )
                                   })
                                }                                 
                            </Slider>
                    </div>
                </div>
            </div>
      </section>
    )
}


export default testimonials;